import { colors } from "@/styles/colors"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(({
	gridContainer: {
		height: "100%"
	},
	icon: {
		color: colors.green[400]
	},
	title: {
		fontSize: "32px",
		lineHeight: "42px",
		color: colors.gray[950],
		textAlign: "center"
	},
	subtitle: {
		maxWidth: 400,
		textAlign: "center",
		color: colors.gray[600]
	},
	closeIcon: {
		color: colors.red[400]
	}
}))

export default useStyles
